import {Box, makeStyles, Typography} from "@material-ui/core";
import {CheckboxGradient} from "../../../../../../../../../../components/CheckboxGradient";
import React, {FC, useEffect, useState} from "react";
import {AccessibilityUnit} from "../../../../../../../../../../../models/AccessibilityUnits";
import styled from "@emotion/styled";
import {useSelector} from "../../../../../../../../../../../redux/store";
import {AppStateType} from "../../../../../../../../../../../redux/reducers";
import {getTextByCurrentLanguage} from "../../../../../../../../../../../utils/functions";

const CompositeUnitGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: 36px;
`

type CompositeUnitProps = {
  borderColor?: string
}

const CompositeUnit = styled.div<CompositeUnitProps>`
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 10px;
  background: rgb(32, 45, 63);
  border: 1px solid ${(props) => props.borderColor ? props.borderColor : 'rgba(238, 238, 238, 0.04)'};
`

const useStyles = makeStyles({
  selectedText: {
    backgroundImage: 'linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%)',
    '-webkit-background-clip': 'text',
    color: 'transparent',
  },
  selectedIcon: {
    color: '#86f7be'
  },
})

type PropsType = {
  id: string;
  selectedUnit: AccessibilityUnit;
  localUnits: AccessibilityUnit[]
  onSelectUnit: (unit: AccessibilityUnit) => void
  onHandleUnitCheckbox: (unit: AccessibilityUnit) => void
}

const CompositeUnits: FC<PropsType> = ({
  id,
  localUnits,
  selectedUnit,
  onSelectUnit,
  onHandleUnitCheckbox
}) => {
  const classes = useStyles()

  const getCompositeUnits = (id: string, units: AccessibilityUnit[]) => {
    if (units.length > 0) {
      const filteredRelatedUnits = units.filter((i) => i.related_to && i.related_to.includes(id))
      if (filteredRelatedUnits.length > 0) {
        return filteredRelatedUnits
      }
    }
    return []
  }

  return (
    <React.Fragment>
      {getCompositeUnits(id,localUnits).length > 0 ? (
        <CompositeUnitGroup>
          {getCompositeUnits(id,localUnits).map((u: any, index: number) => (
            <Box display={'flex'} alignItems={'center'} style={{marginTop: 10}} key={index}>
              <CompositeUnit borderColor={selectedUnit?.id === u.id ? '#86f7be' : ''}>
                <Box
                  display={'flex'}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                  width={'100%'}
                  style={{cursor: 'pointer', padding: '15px 10px'}}
                  onClick={() => onSelectUnit(u)}
                >
                  <Typography
                    className={selectedUnit?.id === u.id ? classes.selectedText : ''}
                  >
                    {getTextByCurrentLanguage(u.name)}
                  </Typography>
                </Box>
                <Box pr={2}>
                  <CheckboxGradient
                    checked={u.is_active}
                    onChange={() => onHandleUnitCheckbox(u)}
                  />
                </Box>
              </CompositeUnit>
            </Box>
          ))}
        </CompositeUnitGroup>
      ) : null}
    </React.Fragment>
  )
}

export default CompositeUnits